import React from "react";

import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";

import { required } from "@jazasoft/mui-table";

import MuiTable from "../../../../components/MuiTable";
import useDeepMemo from "../../../../hooks/useDeepMemo";
import { isEmpty } from "../../../../utils/helpers";

const CutPlanAdjustDialog = ({ open, orderFlow, flowInfoList, onSubmit, onClose }) => {
  const styleCount = orderFlow?.styleList?.length;
  const colorCount = orderFlow?.colorList?.length;

  const columns = useDeepMemo(() => {
    let cols = [
      { dataKey: "style", title: "Style" },
      { dataKey: "color", title: "Color" },
      { dataKey: "orderQty", title: "Order Qty" },
      {
        dataKey: "extra",
        title: "Extra(%)",
        inputType: "text-input",
        options: { type: "number" },
        validate: [required()]
      },
      {
        dataKey: "cutAll",
        title: "Cut All",
        inputType: "boolean-input"
      }
    ];
    if (styleCount <= 1 && colorCount <= 1) {
      cols = cols.filter(c => c.dataKey !== "styleColor");
    }
    return cols;
  }, [styleCount, colorCount]);

  const rows = useDeepMemo(() => {
    if (isEmpty(flowInfoList)) return [];

    const extraPercentList = orderFlow?.orderConfig?.setting?.extraCutPercentList || [];
    if (isEmpty(extraPercentList)) {
      const rows = orderFlow?.styleColorList?.map(styleColor => {
        const fiList = flowInfoList.filter(e => e.styleColor === styleColor);
        if (isEmpty(fiList)) return {};
        const orderQty = fiList.reduce((acc, e) => acc + (e.orderQty || e.fpoQty), 0);
        return { style: fiList[0].style, color: fiList[0].color, orderQty, extra: 0.0 };
      });
      return rows;
    } else {
      return extraPercentList;
    }
  }, [flowInfoList, orderFlow]);

  const handleSubmit = (values, form, onActionComplete) => {
    onSubmit && onSubmit(values, onActionComplete);
  };

  const onFooterActionClick = (event, action, rows) => {
    if (action === "cancel") {
      onClose && onClose();
    }
  };

  return (
    <Dialog id="adjust-dialog" fullWidth={true} maxWidth="sm" open={open} onClose={onClose}>
      <DialogTitle id="import-dialog-title">Adjust Cut Plan</DialogTitle>
      <MuiTable columns={columns} rows={rows} rowAddCount={1} editable editing onSubmit={handleSubmit} onFooterActionClick={onFooterActionClick} />
    </Dialog>
  );
};

export default CutPlanAdjustDialog;
